import { render, staticRenderFns } from "./lang.vue?vue&type=template&id=00139bd3&scoped=true"
import script from "./lang.vue?vue&type=script&lang=js"
export * from "./lang.vue?vue&type=script&lang=js"
import style0 from "./lang.vue?vue&type=style&index=0&id=00139bd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00139bd3",
  null
  
)

export default component.exports